import * as Actions from '../../actions';

const initialState = { data: null };

const viewBaseTransfersReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_BASE_TRANSFERS_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default viewBaseTransfersReducer;
